const init = () => {
    $('a.skip-to-main').on('click', (e) => {
        $(e.target).trigger('blur');
    });
};

export { init };
